import { assertNotEmpty } from '@festina-life/core'

import {
  assertSimpleValueSetupField,
  assertTemplateReferenceValueSetupField,
} from '../../../types/templateModel'
import { SimpleFieldValue } from '../../simpleFieldValue/SimpleFieldValue'
import { TemplateParentLink } from '../../templateParentLink/TemplateParentLink'
import type { SpecialCaseComponentProps } from '../types'
import { useSpecialCasedSubTemplatedFieldVariant } from '../useSpecialCasedSubTemplatedFieldVariant'

export const CcCalcStepFieldValueMainContent = ({
  data,
}: SpecialCaseComponentProps) => {
  const variant = useSpecialCasedSubTemplatedFieldVariant(data)
  const valueField = variant?.fields.find(
    (field) => field.name === 'value' || field.name === 'bool',
  )

  if (valueField) {
    assertSimpleValueSetupField(valueField)

    return <SimpleFieldValue field={valueField} />
  } else {
    const groupField = variant?.fields.find((field) => field.name === 'group')
    assertNotEmpty(groupField)
    assertTemplateReferenceValueSetupField(groupField)

    const source = groupField.value?.variants.at(0)?.source

    return source ? (
      <div className="flex w-full items-center justify-center">
        <TemplateParentLink
          templateId={source}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    ) : null
  }
}
